import React from "react";
import "../../../styles/home/home.css";
import DashboardCard from "../../../pages/home/common/DashboardCard";

const InitiatedJobStats = ({ allJobStats }) => {
  return (
    <div className="cards-container cards-grid-container grid-4 mt-2rem">
      {allJobStats &&
        Object.entries(allJobStats).map(([key, value], index) => (
          <React.Fragment key={index}>
            <DashboardCard
              tagName={"campaign"}
              cardLabel={`${key?.replace(/_/g, " ")}`}
              value={value || 0}
            />
          </React.Fragment>
        ))}

      {/* <DashboardCard
        tagName={"campaign"}
        cardLabel={"Total Calls"}
        value={allJobStats?.total_call || 0}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Incoming Calls"}
        value={allJobStats?.total_incoming_call || 0}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Outgoing Calls"}
        value={allJobStats?.total_outgoing_call || 0}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Connected Calls"}
        value={allJobStats?.total_connected_call || 0}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Missed Calls"}
        value={allJobStats?.total_missed_call || 0}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Connected Incoming Calls"}
        value={allJobStats?.total_incoming_connected_call || 0}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Connected Outgoing Calls"}
        value={allJobStats?.total_outgoing_connected_call || 0}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Missed Incoming Calls"}
        value={allJobStats?.total_incoming_missed_call || 0}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Missed Outgoing Calls"}
        value={allJobStats?.total_outgoing_missed_call || 0}
      /> */}
    </div>
  );
};

export default InitiatedJobStats;
